// extracted by mini-css-extract-plugin
export default {"root":"Quotes__root--z1gd0","quote-toggle":"Quotes__quote-toggle--vBJjb","quoteToggle":"Quotes__quote-toggle--vBJjb","selected":"Quotes__selected--vYP0X"};